import React from "react";
import { Link } from "react-router-dom";
import GraphicStorageConst from '../graphic-storage-const';

const basePath = GraphicStorageConst.basePath;

const GraphicStorageLinkField = ({ id, title }) => {
    return (
        <Link to={`${basePath}/${id}/graphics`}>
            {title}
        </Link>
    );
};

export default GraphicStorageLinkField;
